import { useState } from "react";
import type { TeacherDashboardSummary } from "../../api/teacherWeb";
import { formatCount, formatDate, linkStatus } from "./dashboardModel";

function Balance({ title, total, used, remaining }: { title: string; total: number; used: number; remaining: number }) {
  const format = (n: number) => `${formatCount(n)}${n === -1 ? "" : " 次"}`;
  return <div className="td-balance"><div><h3>{title}</h3><span>剩余</span></div>
    <strong className={remaining === 0 ? "is-empty" : ""}>{format(remaining)}</strong>
    <div className="td-track" role="meter" aria-label={`${title}已用`} aria-valuemin={0} aria-valuemax={total > 0 ? total : 1} aria-valuenow={total > 0 ? Math.min(total, used) : 0} aria-valuetext={`已用 ${format(used)}，总额 ${format(total)}`}>
      <i style={{ width: total > 0 ? `${Math.min(100, used / total * 100)}%` : "0%" }} /></div>
    <dl><div><dt>已用</dt><dd>{format(used)}</dd></div><div><dt>总额</dt><dd>{format(total)}</dd></div></dl>
  </div>;
}

export function ContractPanel({ summary, selectedLinkId, isDemo }: { summary: TeacherDashboardSummary; selectedLinkId: number | null; isDemo: boolean }) {
  const quota = summary.quota;
  const [copyStatus, setCopyStatus] = useState("");
  const links = summary.links.filter(link => selectedLinkId === null || link.id === selectedLinkId);
  async function copyLink(token: string) {
    try { await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}#/t/${encodeURIComponent(token)}`); setCopyStatus("学生入口已复制"); }
    catch { setCopyStatus("复制失败，请检查浏览器剪贴板权限后重试。"); }
  }
  return <aside className="td-contracts" aria-label="合作合同与班级链接">
    <header className="td-section-header"><div><h2>合作合同</h2><p>{selectedLinkId === null ? "各班级生效合同合计" : "当前班级生效合同"}</p></div><span className="td-readonly">只读</span></header>
    {!quota.activeContractCount ? <p className="td-contract-notice">暂无生效合同，请联系管理员核对合同日期与额度。</p> : null}
    <Balance title="AI教练" total={quota.quotaCount} used={quota.usedCount} remaining={quota.remainingCount} />
    <div className="td-contract-foot"><p>按合同起止日期累计使用，不按月刷新。</p><p>各班级额度独立使用，不能互相借用。</p>
      {quota.periodEnd ? <p>{selectedLinkId === null && quota.activeContractCount > 1 ? "AI合同最晚到期" : "AI合同到期"}：{formatDate(quota.periodEnd, false)}</p> : null}
</div>
    <details className="td-link-details"><summary>班级链接 <span>{links.length}</span></summary>
      {links.length ? links.map(link => <div className="td-link-row" key={link.id}><strong>{link.title || `班级 ${link.id}`}</strong><p>{linkStatus(link)} · {link.studentCount} 条学生绑定</p>
        <p>{link.expiresAt ? `链接到期：${formatDate(link.expiresAt, false)}` : "链接未设到期日"}</p>
        <button type="button" className="td-text-button" disabled={isDemo} onClick={() => void copyLink(link.token)}>{isDemo ? "示例链接" : "复制学生入口"}</button></div>) : <p>暂无班级链接</p>}
      <p className="td-contract-foot">链接停用与合同日期分别管理；停用不会把额度转给其他班级。</p>
    </details><p className="td-copy-status" role="status">{copyStatus}</p>
  </aside>;
}
